import { restApi } from '../../services/Api'
import { isEmpty } from 'ramda'
import moment from 'moment'

const solicitacoesHistoricoRepository = {}

solicitacoesHistoricoRepository.list = async params => {
  const where = {}
  if (params.query.motorista) {
    where.motorista = { ilike: `%${params.query.motorista}%` }
  }
  if (params.query.cpf) {
    where.cpf = { like: params.query.cpf }
  }
  if (params.query.placa) {
    where.placa = { ilike: params.query.placa.split('').join('%') }
  }
  if (params.query.placa) {
    where.placa = { ilike: `%${params.query.placa}%` }
  }
  if (params.query.createdAt) {
    where.createdAt = {
      gte: moment(params.query.createdAt)
        .startOf('day')
        .toISOString()
    }
  }
  if (params.query.dataTermino) {
    where.dataTermino = {
      lte: moment(params.query.dataTermino)
        .startOf('day')
        .toISOString()
    }
  }
  const filter = {
    where,
    paginate: params.paginate,
    order: params.query.order
  }
  if (!isEmpty(where)) {
    const response = await restApi.get('/solicitacoes/historico', { filter })
    const responseCount = await restApi.get('/solicitacoes/countHistory', { where })
    return {
      ok: response.ok,
      data: response.data,
      count: responseCount.ok ? responseCount.data.count : undefined
    }
  } else {
    return {
      ok: true,
      data: [],
      count: 0
    }
  }
}

solicitacoesHistoricoRepository.getOne = async id =>
  await restApi.get(`/solicitacoes/historico/${id}`)

export default solicitacoesHistoricoRepository
